export default __webpack_public_path__ + "static/media/file-img.ae4d75e8.svg";